export default "__VITE_ASSET__Bd1mwFxO__"